import { Track } from '@volvo-cars/tracking';

import { JsonRecord } from 'libs/cms/parse/types';

import { getSpecDownloadHref, getSpecFileName } from './impl/specification';

const eventInfo = 'Download specification for';

const DownloadSpecButton: React.FC<{
  apiId: string;
  openApiSpec: JsonRecord;
}> = ({ apiId, openApiSpec }) => {
  return (
    <Track eventAction="link|click" eventLabel={`${eventInfo} ${apiId}`}>
      <a
        href={getSpecDownloadHref(openApiSpec)}
        download={getSpecFileName(apiId)}
        className="button-outlined"
        data-size="small"
      >
        Download specification
      </a>
    </Track>
  );
};

export default DownloadSpecButton;
